import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { captionTight, logoFrame, logoPlaceholderText } from '../styles';

interface LogoSectionProps {
  logoUrl?: string;
  logoUploading: boolean;
  logoError?: string;
  onLogoUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
  labels: {
    checkinsEmailLogoLabel?: string;
    checkinsEmailLogoHelp?: string;
    logoPlaceholder?: string;
    logoUploading?: string;
    uploadLogoCta?: string;
  };
}

const LogoSection: React.FC<LogoSectionProps> = ({
  logoUrl,
  logoUploading,
  logoError,
  onLogoUpload,
  labels,
}) => (
  <Stack spacing={2}>
    <Stack direction="row" spacing={2} alignItems="center">
      <Box sx={logoFrame}>
        {logoUrl ? (
          <Box
            component="img"
            src={logoUrl}
            alt={labels.checkinsEmailLogoLabel || 'Logo'}
            sx={{ width: '100%', height: '100%', objectFit: 'contain' }}
          />
        ) : (
          <Typography
            variant="caption"
            color="text.secondary"
            sx={logoPlaceholderText}>
            {labels.logoPlaceholder || 'Logo'}
          </Typography>
        )}
      </Box>
      <div>
        <Button variant="outlined" component="label" disabled={logoUploading}>
          {logoUploading
            ? labels.logoUploading || 'Uploading…'
            : labels.uploadLogoCta || 'Upload logo'}
          <input hidden accept="image/*" type="file" onChange={onLogoUpload} />
        </Button>
        <Typography variant="caption" display="block" sx={captionTight}>
          {labels.checkinsEmailLogoHelp ||
            'Shown at the top of the welcome email.'}
        </Typography>
        {logoError ? (
          <Typography variant="caption" color="error">
            {logoError}
          </Typography>
        ) : null}
      </div>
    </Stack>
  </Stack>
);

export { LogoSection };
